import React, { createContext, useContext, useState } from 'react';

const TypeContext = createContext({
  type: '',
  setType: (type: string) => {}
});

export const TypeProvider = ({ children }: { children: React.ReactNode }) => {
  const [type, setType] = useState('');

  return (
    <TypeContext.Provider value={{ type, setType }}>
      {children}
    </TypeContext.Provider>
  );
};

export const useType = () => useContext(TypeContext);